<template>
    <div class="home">
        <RibbonTags
            class="noselect"
            ref="ribbon"
            :codeTexts="codeTexts"
            :columns="columns"

            :equipment="equipment"
            :equipments="equipments"

            @updateView="updateView"
            @updateVisibleColumns="updateVisibleColumns"
            @addNewTag="addNewTag"
            @saveTags="saveTags"
            @codeTexts="codeTexts = $event"
        />
        <CedexTags
            v-if="initialData.serviceTypes"
            ref="cedexTags"
            :codeTexts="codeTexts"
            :columns="columns"

            :equipment="equipment"
            :show-inactive="showInactive"
            :tags.sync="tags"
            :dependencies.sync="dependencies"
            :selectableDependencies="initialData.dependencies"

            :tagTypes="tagTypes"
            :serviceTypesArray="initialData.serviceTypes"
            :locationCodes="locationCodes"
            :componentCodes="componentCodes"
            :isoCodes="isoCodes"
            :damageCodes="initialData.damageCodes"
            :repairCodes="initialData.repairCodes"
            :inspectionCriterias="initialData.inspectionCriteria"
            :leasingCompanys="initialData.leasingCompanies"
            :shippingLines="initialData.shippingLines"
            :carcassManufacturers="initialData.carcassManufacturers"
            :machineryManufacturers="initialData.machineryManufacturers"
            :modelNumberPatterns="initialData.modelNumberPatterns"

            :isoCodeToSurveyTypeName="initialData.isoCodeToSurveyTypeName || null"
            :locationCodePrefixToViewTypeName="initialData.locationCodePrefixToViewTypeName || null"

            @updateView="updateView"
            @filterData="filterData"
            @showMessage="showMessage"
        />
        <v-snackbar
            v-model="messageBox.show"
            :timeout="messageBox.closeTimeout"
            light
            class="coa_snack"
            :class="'coa_' + messageBox.type"
        ><span style="white-space: pre;">{{ messageBox.content }}</span>
            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-show="messageBox.closeTimeout === 0"
                    v-bind="attrs"
                    @click="messageBox.show = false"
                >{{ messageBox.closeButtonText }}
                </v-btn>
            </template>
        </v-snackbar>
        <div v-show="loading" class="loading"><div v-if="loadingMessage!==''" class="loadingMessage">{{$t(loadingMessage)}}...</div></div>
    </div>
</template>

<script>
import RibbonTags from '@/components/Ribbon/RibbonTags.vue'
import CedexTags from '@/components/Tags/CedexTags.vue'
import axios from "axios";
import i18n from "../i18n";
import {popupShowTime} from "../plugins/constants";

export default {
    name: 'Tags',
    components: {
        RibbonTags,
        CedexTags
    },
    created() {
        this.showLoading('loading initial data');
        this.$emit('updateHeaderNavigation', [{
            display: i18n.t('CEDEX Tag Editor')
        }]);
        this.loadInitialData();
    },
    data: () => ({
        loading: false,
        loadingMessage: '',
        initialData: {},
        messageBox: {
            show: false,
            content: '',
            closeButtonText: 'ok',
            closeTimeout: -1,
        },
        columns: [
            {id: 'name', title: 'Tag Name (EN)', visible: true, width: 90, filter: true},
            {id: 'nameDe', title: 'Tag Name (DE)', visible: true, width: 90, filter: true},
            {id: 'nameRu', title: 'Tag Name (RU)', visible: true, width: 90, filter: true},
            {id: 'internal', title: 'Internal', visible: true, width: 64, filter: true, boolean: true},
            {id: 'decisionRequired', title: 'Decision Required', visible: true, width: 104, filter: true, boolean: true},
            {id: 'priceRelevant', title: 'Price Relevant', visible: true, width: 104, filter: true, boolean: true},
            {id: 'active', title: 'Active', visible: true, width: 64, filter: true, boolean: true},
            {id: 'files', title: 'Files', visible: true, width: 48},
            {id: 'tagType', title: 'Tag Type', visible: true, width: 72, filter: true},
            {id: 'tagDisplay', title: 'Tag Display', visible: true, width: 88, filter: true},
            {id: 'serviceType', title: 'Service Type', visible: true, width: 80, filter: true, multiselect: true},
            {id: 'isoCode', title: 'ISO Code', visible: true, width: 152, filter: true, multiselect: true},
            {id: 'locationCode', title: 'Location Code', visible: true, width: 152, filter: true, multiselect: true},
            {id: 'componentCode', title: 'Component Code', visible: true, width: 152, filter: true},
            {id: 'damageCode', title: 'Damage Code', visible: true, width: 152, filter: true},
            {id: 'repairCode', title: 'Repair Code', visible: true, width: 152, filter: true},
            {
                id: 'inspectionCriteria',
                title: 'Inspection Criteria',
                visible: true,
                width: 120,
                filter: true,
                multiselect: true
            },

            {
                id: 'leasingCompany',
                title: 'Leasing Company',
                visible: true,
                width: 152,
                filter: true,
                multiselect: true
            },
            {id: 'shippingLine', title: 'Shipping Line', visible: true, width: 152, filter: true, multiselect: true},
            {id: 'carcassManufacturer', title: 'Carcass Manufacturer', visible: true, width: 152, filter: true},
            {id: 'machineryManufacturer', title: 'Machinery Manufacturer', visible: true, width: 152, filter: true},
            {
                id: 'modelNumberRange',
                title: 'Model No.',
                visible: true,
                width: 152,
                filter: true
            },

            {id: 'actions', title: 'Actions', visible: true, width: 56},
        ],
        currentView:  'CEDEX Tags',
        codeTexts:    true,
        equipment:    'carcass',
        showInactive: false,
        equipments: [
            {id: 'carcass', name: i18n.t('Carcass')},
            {id: 'machinery', name: i18n.t('Machinery')},
            {id: 'tank', name: i18n.t('Tank')},
        ],
        tagTypes: {
            component: 'Component',
            damage:    'Damage',
            repair:    'Repair',
        },

        tags: {},
        dependencies: {},

        sortingColumn:    null,
        sortingDirection: null,
        filters:          {}
    }),
    methods: {
        showLoading(message)
        {
            this.loading        = true;
            this.loadingMessage = message || '';
        },
        hideLoading()
        {
            this.loading        = false;
            this.loadingMessage = '';
        },
        loadInitialData: async function ()
        {
            await axios.get('cedexTags/initialData').then(response => {
                this.initialData = response.data;

                // convert machinery model number patterns into partial regExes
                if (this.initialData.modelNumberPatterns) {
                    Object.keys(this.initialData.modelNumberPatterns).forEach((manufacturerId) => {
                        let regExString = this.initialData.modelNumberPatterns[manufacturerId];
                        this.initialData.modelNumberPatterns[manufacturerId] = (new RegExp(regExString)).toPartialMatchRegex();
                    })
                }

                this.hideLoading();
                return response;
            }).catch(error => {
                console.log(error);
                this.showMessage(i18n.t('Tags loading failed.'), 'error', popupShowTime);
            });
        },
        updateView: function (updateType, updateValue, source)
        {
            this[updateType] = updateValue;
            this.tags = {};
            if (updateType === 'sortingColumn') {
                this.sortingDirection = source;
            } else {
                this.sortingColumn = null;
                this.sortingDirection = null;
            }

            const triggerDataLoadTypes = ['equipment', 'showInactive', 'sortingColumn', 'filters'];

            if (triggerDataLoadTypes.includes(updateType)) {
                this.showLoading('loading tag data');
                axios.get('cedexTags', {
                    params: {
                        equipment:        this.equipment,
                        showInactive:     this.showInactive,
                        sortingColumn:    this.sortingColumn,
                        sortingDirection: this.sortingDirection,
                        filters:          this.filters
                    }
                }).then(response => {
                    this.showMessage(i18n.t('Tags loaded.'), 'success', popupShowTime);
                    this.hideLoading();
                    this.$refs.cedexTags.currentPage = 1;

                    if (Object.keys(response.data).length === 0) {
                        this.tags         = {};
                        this.dependencies = {};
                    } else {
                        this.tags         = Array.isArray(response.data.tags)         ? {} : response.data.tags;
                        this.dependencies = Array.isArray(response.data.dependencies) ? {} : response.data.dependencies;
                    }
                    this.$refs.cedexTags.failedValidation = {};

                    window.showBeforeUnload = false;
                });
            }
        },
        updateVisibleColumns: function (visibleColumns) {
            this.visibleColumns = visibleColumns;
        },
        filterData(filters, showResultGroup)
        {
            this.updateView('filters', filters, showResultGroup);
        },
        addNewTag: function () {
            this.$refs.cedexTags.addRow();
        },
        saveTags: async function () {
            const res = await this.$dialog.confirm({
                text: i18n.t('Do you really want to save your current settings?'),
                title: i18n.t('Save CEDEX Tags'),
                persistent: true,
                actions: {
                    false: 'No',
                    true: 'Yes',
                },
            });

            if (!res) {
                return;
            }

            this.showLoading('saving tag data');
            let data;
            try {
                data = this.$refs.cedexTags.collectData();
            } catch (e) {
                this.hideLoading();
                return;
            }
            let params = new FormData();
            params.append('equipment', this.equipment);
            params.append('tagData', JSON.stringify(data.tagData));
            params.append('removedTagIds', JSON.stringify(data.removedTagIds));

            axios
                .post('cedexTags', params)
                .then(response => {
                    this.hideLoading();
                    if (
                        response.status === 200
                        && response.data.success
                    ) {
                        this.showMessage(i18n.t('Tags saved.'), 'success', popupShowTime);
                        window.showBeforeUnload = false;
                    } else {
                        this.showMessage(i18n.t('Tags saving failed.'), 'error', popupShowTime);
                    }
                })
                .catch(error => {
                    this.hideLoading();
                    this.showMessage(i18n.t('Tags saving failed.'), 'error', popupShowTime);
                    console.log(error);
                });
        },
        showMessage(content, type, close, buttonText) {
            this.messageBox.content = content;
            this.messageBox.type = type;
            this.messageBox.show = true;
            if (typeof close === 'number') {
                this.messageBox.closeTimeout = close;
            } else {
                this.messageBox.closeTimeout = -1;
            }
            if (buttonText) {
                this.messageBox.closeButtonText = buttonText;
            } else {
                this.messageBox.closeButtonText = 'ok';
            }
        }
    },
    computed: {
        isoCodes() {
            if (!this.initialData.equipmentsToIsoCodes) {
                return {};
            }
            return this.initialData.equipmentsToIsoCodes[this.equipment];
        },
        componentCodes() {
            if (!this.initialData.equipmentsToComponentCodes) {
                return {};
            }
            return this.initialData.equipmentsToComponentCodes[this.equipment];
        },
        locationCodes() {
            if (!this.initialData.equipmentsToLocationCodes) {
                return {};
            }
            return this.initialData.equipmentsToLocationCodes[this.equipment];
        }
    }
}
</script>
